import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminProtectedRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    // You can return a loading spinner here
    return <div>Loading...</div>;
  }

  if (user && isAdmin()) {
    return children;
  }

  return <Navigate to="/admin" state={{ from: location }} replace />;
};

export default AdminProtectedRoute;
